import {
  getLengthOfStayDiscount,
  LENGTH_OF_STAY_DISCOUNT_LABELS,
} from '@/utils/get-length-of-stay-discount';
import { Rate } from '@/utils/platform-api/__generated__/graphql';
import { getRateDiscount } from '@/utils/rate-totals';

export type RateDiscountLine = {
  label: string;
  amount: number;
};

export const getRateDiscountLines = (
  rate: Pick<Rate, 'discount'>,
  checkIn?: string,
  checkOut?: string
): RateDiscountLine[] => {
  const discount = getRateDiscount(rate);
  if (discount <= 0) {
    return [];
  }

  return [
    {
      label:
        checkIn && checkOut
          ? getLengthOfStayDiscount(checkIn, checkOut)
          : LENGTH_OF_STAY_DISCOUNT_LABELS[0],
      amount: discount,
    },
  ];
};
